import React, { useEffect, useMemo, useState, useRef } from "react";
import { get, useForm } from "react-hook-form";
import { BsSearch, BsEnvelope, BsInfoCircle } from "react-icons/bs";
import { GiPayMoney, GiReceiveMoney } from "react-icons/gi";
import { IoMdAlert } from "react-icons/io";
import {
    RiUserReceivedLine,
    RiUserSharedLine,
  } from "react-icons/ri";

import { useRemmitances } from "../../../../hooks/useRemmitances";
import NotifyC from "../../../../components/Notifications";
import { TbZoomReset } from "react-icons/tb";
import { getUser, formatCurrency, sqlDateFormat, getRemittanceType,printInvoice, normalizeIdNumber,idFormats, validateIdFormat,  provincesPrefix,updateFullId  } from "../../../../utils/Common";
import Spinner from "../../../../components/Spinner";
import { FaCheckCircle, FaAngleDoubleLeft, FaAngleDoubleRight, FaPlus, FaMinus, FaRedo } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import Swal from "sweetalert2";
import LockScreen from "../../../../components/ui/LockScreenCash";
import "../../index.css";
import SelectSearch from "../../../../components/ui/SelectSearch";
import { useCash } from "../../../../hooks/useCash";
import { useClient } from "../../../../hooks/useClient";

  const DeliverRemittances = () => {
  const { getRemmitancesByFilter, confirmDeliverRemittanceById } = useRemmitances();
  const { register, handleSubmit, reset, errors, watch } = useForm();
  const { getClientById } = useClient();

  // Agregar CSS de animación
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [dataRemittances, setDataRemittances] = useState(null);
  const user = getUser();
  const contentRef = useRef();
  const [idType, setIdType] = useState("cedula");
  const [loadingInputs, setLoadingInputs] = useState({ sender: false, recipient: false });
  const [showSecondRecipient, setShowSecondRecipient] = useState(false); 
  const [idPrefix, setIdPrefix] = useState(null);
  const [refundType, setRefundType] = useState(""); // Nuevo estado para tipo de reintegro
  const [currentOperationType, setCurrentOperationType] = useState(null); // Estado para el tipo de operación actual
  const [loadingOperation, setLoadingOperation] = useState(null); // Estado para rastrear qué operación está cargando
  const [showTooltip, setShowTooltip] = useState(false); // Estado para mostrar/ocultar tooltip
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 }); // Posición del tooltip
  const tooltipRef = useRef(null); // Referencia para el tooltip
  const idOptions = idFormats();
  const idProvinces = provincesPrefix();

  // Función para calcular la posición del tooltip
  const calculateTooltipPosition = (event) => {
    const rect = event.target.getBoundingClientRect();
    const tooltipWidth = 400; // Ancho estimado del tooltip
    const tooltipHeight = 200; // Alto estimado del tooltip
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    
    let top = rect.bottom + 10;
    let left = rect.left + (rect.width / 2) - (tooltipWidth / 2);
    
    // Ajustar si se sale por la derecha
    if (left + tooltipWidth > viewportWidth - 20) {
      left = viewportWidth - tooltipWidth - 20;
    }
    
    // Ajustar si se sale por la izquierda
    if (left < 20) {
      left = 20;
    }
    
    // Ajustar si se sale por abajo
    if (top + tooltipHeight > viewportHeight - 20) {
      top = rect.top - tooltipHeight - 10;
    }
    
    return { top, left };
  };

  // Función para mostrar el tooltip
  const handleShowTooltip = (event) => {
    const position = calculateTooltipPosition(event);
    setTooltipPosition(position);
    setShowTooltip(true);
  };

  // Función para ocultar el tooltip
  const handleHideTooltip = () => {
    setShowTooltip(false);
  };

  const renderInputForm = (field, label, required, type, Icon, placeholder) => (
    <div
      className="input-group text-left"
      style={{
        width: "100%",
        maxWidth: "400px",
      }}
    >
      <div className="input-group-prepend d-flex align-items-center">
        <span
          className="input-group-text text-bold"
          style={{
            backgroundColor: "#FBD825",
            color: "black",
          }}
        >
          {Icon && <Icon className="mr-2" size={18} />} {label}
        </span>
      </div>
      <input
        type={type ?? "text"}
        className="form-control"
        name={field}
        ref={register({
            required: required ? "Este campo es obligatorio" : false,
          })}
        required={required}
        placeholder={placeholder}
      />

      {errors[field] && (
        <span className="text-danger">{errors[field].message}</span>
      )}
    </div>
  );

  const renderInput = (label, value) => (
    <div className="col-12 col-md-6 col-lg-3 form-group text-left">
    <label>
      {label} 
    </label>
    <input
      type={"text"}
      className="form-control text-uppercase"
      disabled
      value={value}
    />
  </div>
  );

  const renderInputSecondary = (section, field, label, required, mask, setIdType, idType) => {
    return ( <>
      {!mask ?( <>
      <div className="col-12 col-md-6 col-lg-3 form-group text-left">
      <label>
        {label}  {required && <span className="text-danger">*</span>}
      </label>
      <input
        type={"text"}
        className="form-control"
        name={`${section}.${field}`}
        ref={register({
          required: required ? "Este campo es obligatorio" : false,
        }
        )}
        disabled={loadingInputs[section]}
      />
          {loadingInputs[section] && (
          <div
            style={{
              position: "absolute",
              right: "5%",
              top: "50px", 
              transform: "translateY(-50%)",
            }}
          >
            <Spinner type={1}/> 
          </div>
        )}
         </div>
      </>) : (<> 
        <div className="col-12 col-md-12 col-lg-6 form-group text-left">
        <label>
          Número de Identificación
          <span className="text-danger">*</span>
        </label>
        <div className="input-group">
              <div className="input-group-append">
            <SelectSearch
              options={idOptions}
              nameInput="idType"
              setValue={(_, value) => setIdType(value)}
              value={idType}
              isRequired
              className="form-control"
              style={{ width: "auto" }}
            />
          </div>  
          {["cedula-E", "cedula-N"].includes(idType) ? (
                <>
                  <div className="ml-2">
                    <input
                      type="text"
                      className="form-control combo-input prefix-display-input"
                      value={`${idType.split("-")[1]}-`}
                      readOnly
                      aria-label="Tipo de cédula"
                    />
                  </div>
                  <div className="input-group-append">
                    <div className="input-group-append">
                      <SelectSearch
                        options={idProvinces}
                        nameInput="Prefix"
                        setValue={(_, value) => setIdPrefix(value)}
                        value={idPrefix}
                        isRequired
                        className="form-control"
                        style={{ width: "auto" }}
                      />
                    </div>
                  </div>
                  <span className="input-group-text">-</span>
                </>
              ) : idType === "cedula-PE" ? (
                <>
                  <div className="ml-2">
                    <input
                      type="text"
                      className="form-control combo-input prefix-display-input"
                      value="PE-"
                      readOnly
                      aria-label="Tipo de cédula"
                    />
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Prefijo"
                    value={idPrefix || ""}
                    onChange={(e) => setIdPrefix(e.target.value)}
                    style={{ maxWidth: "80px" }}
                  />
                  <span className="input-group-text">-</span>
                </>
              ) : ["cedula", "cedula-AV", "cedula-PI"].includes(idType) ? ( <> 
                <div className="ml-2">
                  <SelectSearch
                    options={idProvinces}
                    nameInput="Prefix"
                    setValue={(_, value) => setIdPrefix(value)}
                    value={idPrefix}
                    isRequired
                    className="form-control"
                    style={{ width: "auto" }}
                  />
                   
                </div>
                {["cedula"].includes(idType) &&( 
                  <span className="input-group-text">-</span>
                 )}
           
              </>) : null}
          <input
              type="text"
              placeholder={idOptions.find((option) => option.value === idType)?.placeholder}
              className="form-control"
              name={`${section}.${field}`}
              ref={register()}
              onChange={(event) => { handleIdChange(event, section, idType, idPrefix);}}
            />
        </div>
      </div>
      </>) }
   
      </>)
  };

  const steps = [
    {
      label: "Información del Giro",
      icon: <GiReceiveMoney size={18} />,
      bgIcon: "#fbd825",
      colorIcon: "#000",
      content: (
        <div className="row">
          {renderInput("Nro. giro", dataRemittances?.IdRemesa)}
          {dataRemittances?.IdTipoRemesa && renderInput("Tipo de giro", getRemittanceType(dataRemittances.IdTipoRemesa))}
          {renderInput("Estafeta de origen", dataRemittances?.NombreSucursalOrigen)}
          {renderInput("Estafeta de destino", dataRemittances?.NombreSucursalDestino)}
          {renderInput(`Monto a entregar`, formatCurrency(dataRemittances?.MontoEnviar))}
        </div>
      ),
    },
    {
      label: "Datos del Remitente",
      icon: <RiUserSharedLine size={18} />,
      content: (
        <div className="row mt-3">
          {renderInput("Nombre", dataRemittances?.NombreRemitente)}
          {renderInput("Apellido", dataRemittances?.ApellidoRemitente)}
          {renderInput("Identificación", dataRemittances?.IdRemitente)}
          {dataRemittances?.EmailRemitente && renderInput("Email", dataRemittances.EmailRemitente)}
          {dataRemittances?.TelefonoRemitente && renderInput("Telefono", dataRemittances.TelefonoRemitente)}
          {dataRemittances?.DireccionRemitente && renderInput("Dirección", dataRemittances.DireccionRemitente)}
        </div>
      ),
      bgIcon: "#0c4271",
    },
    {
      label: "Datos del Destinatario",
      icon: <RiUserReceivedLine size={18} />,
      content: (
        <div className="row mt-3">
          {renderInput("Nombre", dataRemittances?.NombreDestinatario)}
          {renderInput("Apellido", dataRemittances?.ApellidoDestinatario)}
          {renderInput("Identificación", dataRemittances?.IdDestinatario)}
          {dataRemittances?.EmailDestinatario && renderInput("Email", dataRemittances.EmailDestinatario)}
          {dataRemittances?.TelefonoDestinatario && renderInput("Telefono", dataRemittances.TelefonoDestinatario)}
          {dataRemittances?.DireccionDestinatario && renderInput("Dirección", dataRemittances.DireccionDestinatario)}
        </div>
      ),
      bgIcon: "#e2131b",
    },
    ...((dataRemittances?.IdEstatus === 1 || dataRemittances?.IdEstatus === 4) && dataRemittances?.IdSucursalDestino === user.IdEstafeta
      ? [
          showSecondRecipient
            ? {
                label: (
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ flex: 1, textAlign: "left" }}>Datos del Destinatario secundario</span>
                    <button
                      type="button"
                      className="btn btn-sm p-1 d-flex align-items-center justify-content-center ml-2"
                      style={{
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        background: "red",
                        border: "none",
                        minWidth: 0,
                      }}
                      onClick={() => setShowSecondRecipient(!showSecondRecipient)}
                      
                    >
                      <FaMinus style={{ color: "white" }} />
                    </button>
                  </div>
                ),
                icon: <RiUserReceivedLine size={18} />,
                colorIcon: "#000",
                content: (
                  <form>
                    <div className="row mt-3">
                      {renderInputSecondary("destinatario2","identification","No. Cédula o pasaporte",false,true,setIdType,idType)}
                      {renderInputSecondary("destinatario2","firstName","Nombre",true,false)}
                      {renderInputSecondary("destinatario2","lastName","Apellido",true,false)}
                      {renderInputSecondary("destinatario2","email","Email",false,false)}
                      {renderInputSecondary("destinatario2","phone","Telefono",false,false)}
                      {renderInputSecondary("destinatario2","address","Dirección",false,false)}
                    </div>
                  </form>
                ),
                bgIcon: "#13e21d",
              }
            : {
                label: "Agregar destinatario secundario",
                icon: (    
                <button
                  type="button"
                  className="btn btn-sm p-1 d-flex align-items-center justify-content-center"
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    background: "#13e21d",
                    border: "none",
                    minWidth: 0,
                  }}
                  onClick={() => setShowSecondRecipient(!showSecondRecipient)}
                  aria-label="Agregar destinatario secundario"
                >
                  <FaPlus style={{ color: "green", fontSize: 16 }} />
                </button>
                ),
                colorIcon: "#000",
              },
        ]
      : []),
      ...((dataRemittances?.IdEstatus === 2 || dataRemittances?.IdEstatus === 3 || dataRemittances?.IdEstatus === 5) && dataRemittances?.IdDestinatario2
    ? [{
        label: "Datos del Destinatario secundario",
        icon: <RiUserReceivedLine size={18} />,
        colorIcon: "#000",
        content: (
          <div className="row mt-3">
            {renderInput("Nombre", dataRemittances?.NombreDestinatario2)}
            {renderInput("Apellido", dataRemittances?.ApellidoDestinatario2)}
            {renderInput("Identificación", dataRemittances?.IdDestinatario2)}
            {dataRemittances?.EmailDestinatario2 && renderInput("Email", dataRemittances.EmailDestinatario2)}
            {dataRemittances?.TelefonoDestinatario2 && renderInput("Telefono", dataRemittances.TelefonoDestinatario2)}
            {dataRemittances?.DireccionDestinatario2 && renderInput("Dirección", dataRemittances.DireccionDestinatario2)}
          </div>
        ),
        bgIcon: "#13e21d",
      }]
    : [])
      
  ];

  const resetForm = () => {
    reset({
      destinatario2: {identification: "",firstName: "",lastName: "",email: "",phone: "",address: "",},
    });
    setDataRemittances(null);
    setLoadingInputs({ sender: false, recipient: false });
    setIdType("cedula");
    setShowSecondRecipient(false);
    setRefundType(""); // Resetear tipo de reintegro
    setCurrentOperationType(null); // Resetear tipo de operación actual
    setLoadingOperation(null); // Resetear operación en carga
  };

  
  const getClientData = async (IdType, IdNumber) => {
    const abortController = new AbortController();
    const data = {
      tipoDocumento: IdType,
      numDocumento: IdNumber,
    };
    try {
      const response = await getClientById(abortController.signal, data);
      if (response && response.length > 0) {
        return response[0]; 
      }
      return null;
    } catch (error) {
      NotifyC.error("Error al obtener los datos del usuario", { duration: 6000 });
      return null;
    }
  }







  const handleIdChange = async (event, section, IdType, idPrefix) => {
    const idNumber = event.target.value;
    const normalizedId = normalizeIdNumber(idNumber, IdType); 
    event.target.value = normalizedId;

    const idNumberFull = updateFullId(idPrefix, normalizedId, IdType); 
  
    const length = IdType === "cedula" ? 7 : IdType === "extranjero" ? 12 : 6; 

    if (idNumberFull.length > length) {
      setLoadingInputs((prev) => ({ ...prev, [section]: true })); 
      const clientData = await getClientData(IdType, idNumberFull);
      setLoadingInputs((prev) => ({ ...prev, [section]: false }));
  
      if (clientData) {
        reset({
          ...watch(),
          [section]: {
            ...watch(section),
            firstName: clientData.NombreSimple || "",
            lastName: clientData.ApellidoSimple || "",
            email: clientData.Email || "",
            phone: clientData.Telefono || "",
            address: clientData.Direccion || "",
          },
        });
        NotifyC.success("Usuario encontrado", { duration: 3000 });
      } 
    }

  };

  const handlePrintPDF = async (IdRemesa, copyNumber, deliver) => {
    const content = contentRef.current;
  
    if (!content) return;

    const dataToSend = { numRemittance: `${IdRemesa}` };
    const response = await getRemmitancesByFilter(new AbortController().signal, dataToSend);
 
    if (response?.code === 200) {
      const remesa = response.payload[0];
      const pdfBlob = await printInvoice(remesa, copyNumber, deliver);
        
          if (pdfBlob) {
            const pdfURL = URL.createObjectURL(pdfBlob);
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = pdfURL;
            document.body.appendChild(iframe);
        
            iframe.onload = () => {
              iframe.contentWindow.print();
            };
          }
    }
  };

   const confirmAction = async (message) => {
     const result = await Swal.fire({
       title: message,
       icon: "info",
       showCancelButton: false,
       confirmButtonText: "Imprimir",
       allowOutsideClick: false,
       allowEscapeKey: false,
       customClass: {
         confirmButton: "custom-confirm-button",
       },
     });
     return result.isConfirmed;
   };

  const handleOnSubmit = async (data) => {
    
    const dataToSend = data;
    const hasAnyFieldFilled = Object.values(dataToSend).some((value) => value);

    if (!hasAnyFieldFilled) {
      NotifyC.error("Por favor, ingrese el PIN para realizar la búsqueda.", {
        duration: 4000,
      });
      return;
    }

    setIsLoading(true);
    const abortController = new AbortController();
    const response = await getRemmitancesByFilter(
      abortController.signal,
      dataToSend
    );  
    
    if (response?.code === 404) {
      NotifyC.error("No se encontraron giros con los datos ingresados.", {
        duration: 6000,
      });
    }

    if (response?.code === 422) {
      NotifyC.error("El tipo de dato ingresado es incorrecto.", {
        duration: 6000,
      });
    }

    if (response?.code === 500) {
      NotifyC.error(
        "Error interno del servidor, intente nuevamente en unos minutos ",
        { duration: 6000 }
      );
    }

    if (response?.code === 200) {
      NotifyC.success(`Giro #${response.payload[0].IdRemesa} encontrado`, {
        duration: 6000,
      });
      setDataRemittances(response.payload[0]);
    }

    setIsLoading(false);
  };

  const handle400Errors = (message) => {
    switch (message) {
      case "REMITTANCE_ALREADY_DELIVERED":
        NotifyC.error("Ops, este giro ya ha sido entregada.", { duration: 6000 });
        break;
      case "REMITTANCE_ALREADY_REINTEGRATED":
        NotifyC.error("Ops, este giro ya ha sido reintegrada.", { duration: 6000 });
        break;
      case "EXPIRED_REMITTANCE_ALREADY_DELIVERED":
        NotifyC.error("Ops, este giro expirado ya ha sido entregado.", { duration: 6000 });
        break;
      case "EXPIRED_REMITTANCE_ALREADY_REINTEGRATED":
        NotifyC.error("Ops, este giro expirado ya ha sido reintegrado.", { duration: 6000 });
        break;
      case "INVALID_REMITTANCE_STATUS_FOR_OPERATION":
        NotifyC.error("Ops, este giro ya ha sido entregado o reintegrado.", { duration: 6000 });
        break;
      case  "CONCURRENT_MODIFICATION_DETECTED":
        NotifyC.error("Ops, este giro ya ha sido modificado por otro usuario.", { duration: 6000 });
        break;
      case "LOCATION_FOR_DELIVER_NOT_MATCH":
        NotifyC.error("Ops, esta estafeta no está autorizada para entregar este giro.", { duration: 6000 });
        break;
      case "LOCATION_FOR_REFUND_NOT_MATCH":
      NotifyC.error("Ops, esta estafeta no está autorizada para reintegrar este giro.", { duration: 6000 });
        break;
      case "CASHBOX_NOT_OPEN":
        NotifyC.error("Ops, la caja se encuentra cerrada. No se puede entregar giros.", { duration: 6000 });
        break;
      case "CASHBOX_NOT_ACTIVE":
        NotifyC.error("Ops, la caja se encuentra desactivada. No se puede entregar giros.", { duration: 6000 });
        break;
      default:
        NotifyC.error("Ops, un dato ingresado es incorrecto.", { duration: 6000 });
        break;
    }
  };

  const handle404Errors = (message) => {
    switch (message) {
      case "INSUFFICIENT_BALANCE_IN_CASHBOX":
        NotifyC.error("Ops, el saldo de la caja es insuficiente para realizar esta acción.", { duration: 6000 });
        break;
      case "ERROR_CREATING_SECONDARY_RECIPIENT":
        NotifyC.error("Ops, ocurrió un error al crear el segundo destinatario.", { duration: 6000 });
        break;
      case "ERROR_DELIVER_REMITTANCE":
        NotifyC.error("Ops, ocurrió un error al entregar el giro.", { duration: 6000 });
        break;
      case "ERROR_REINTEGRATE_REMITTANCE":
        NotifyC.error("Ops, ocurrió un error al reintegrar el giro.", { duration: 6000 });
        break;
      case 'ERROR_DELIVER_EXPIRED_REMITTANCE':
        NotifyC.error("Ops, ocurrió un error al entregar el giro expirado.", { duration: 6000 });
        break;
      case 'ERROR_REINTEGRATE_EXPIRED_REMITTANCE':
        NotifyC.error("Ops, ocurrió un error al reintegrar el giro expirado.", { duration: 6000 });
        break;
      default:
        NotifyC.error("Ops, un dato ingresado es incorrecto.", { duration: 6000 });
        break;
    }
  };

  const confirmDeliverRemittance = async (tipo) => {

    let selectedRefundType = null;

    // Si es reintegro (normal o vencido), solicitar tipo de reintegro
    if (tipo === "Reintegro" || tipo === "ReintegroVencido") {
      selectedRefundType = await selectRefundType();
      if (!selectedRefundType) {
        return; // Usuario canceló
      }
      setRefundType(selectedRefundType);
    }

    // Validar destinatario secundario si está habilitado
    const idNumber = idPrefix && watch("destinatario2.identification")
      ? updateFullId(idPrefix, watch("destinatario2.identification"), idType)
      : null;
    
    const nameSecondRecipient = watch("destinatario2.firstName") ?? null;
    const lastNameSecondRecipient = watch("destinatario2.lastName") ?? null;

    const hasEmptyFields = !idNumber || !nameSecondRecipient || !lastNameSecondRecipient;

    if (showSecondRecipient && hasEmptyFields) {
      NotifyC.error("Por favor, complete los datos requeridos del segundo destinatario.", {
        duration: 4000,
      });
      return;
    }

    if (!hasEmptyFields && validateIdFormat(idNumber, idType) === false) {
      NotifyC.error("El número de identificación no es válido.", {duration: 4000,});
      return;
    }

    const verifyMov = await verifyConfirmUser(tipo);
    if (!verifyMov) {
      return;
    }
    setLoadingOperation(tipo); // Establecer qué operación está cargando

    const dataToSend = {
      remittanceId: dataRemittances.IdRemesa,
      cashId: user.IdCaja,
      type: tipo, 
      refundType: (tipo === "Reintegro" || tipo === "ReintegroVencido") ? selectedRefundType : null,
      secondRecipient: {
        tipoDocumento: idType,
        numDocumento: idNumber ?? null,
        firstName: nameSecondRecipient ?? null,
        lastName: lastNameSecondRecipient ?? null,
        email: watch("destinatario2.email") ?? null,
        phone: watch("destinatario2.phone") ?? null,
        address: watch("destinatario2.address") ?? null,
      },
    };

    try {
      const abortController = new AbortController();
      const response = await confirmDeliverRemittanceById(abortController.signal, dataToSend);

      switch (response?.code) {
        case 404:
          handle404Errors(response?.message);
          break;
        case 422:
          NotifyC.error("El tipo de dato ingresado es incorrecto.", { duration: 6000 });
          break;
        case 500:
          NotifyC.error("Error interno del servidor, intente nuevamente en unos minutos.", { duration: 6000 });
          break;
        case 400:
          handle400Errors(response?.message);
          break;
        case 200:

          // Determinar el mensaje de éxito según el tipo de operación
          let successTitle, successMessage;
          
          switch (tipo) {
                          case "EntregarVencido":
                successTitle = "¡Giro expirado entregado!";
                successMessage = `El giro expirado #${dataRemittances.IdRemesa} ha sido entregado correctamente`;
                break;
              case "ReintegroVencido":
                successTitle = "¡Giro expirado reintegrado!";
                successMessage = `El giro expirado #${dataRemittances.IdRemesa} ha sido reintegrado correctamente`;
                break;
            case "Entregar":
              successTitle = "¡Giro entregado!";
              successMessage = `El giro #${dataRemittances.IdRemesa} ha sido entregado correctamente`;
              break;
            case "Reintegro":
              successTitle = "¡Giro reintegrado!";
              successMessage = `El giro #${dataRemittances.IdRemesa} ha sido reintegrado correctamente`;
              break;
            default:
              successTitle = "¡Operación completada!";
              successMessage = `La operación ha sido completada correctamente`;
          }

          await Swal.fire({
            title: successTitle,
            text: successMessage,
            icon: "success",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
              confirmButton: "custom-confirm-button",
            },
          });

          let printSuccess = false;

          do {
            handlePrintPDF(dataRemittances.IdRemesa, null, true);
            const retry = await Swal.fire({
              title: "¿La impresión fue exitosa?",
              text: "Si hubo un problema (por ejemplo, falta de papel), puede intentar reimprimir.",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Sí",
                    cancelButtonText: "Reimprimir",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    customClass: {
                        confirmButton: "custom-confirm-button",
                        cancelButton: "custom-cancel-button",
                    },
            })
            printSuccess = retry.isConfirmed;
          } while (!printSuccess);

          const printCopy = await confirmAction("Imprimir copia de oficinista");
          if (printCopy) {
            let copyPrintSuccess = false;
            do {
              handlePrintPDF(dataRemittances.IdRemesa, 1, true);
              const retry = await Swal.fire({
                title: "¿La impresión fue exitosa?",
                text: "Si hubo un problema (por ejemplo, falta de papel), puede intentar reimprimir.",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Sí",
                cancelButtonText: "Reimprimir",
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: {
                  confirmButton: "custom-confirm-button",
                  cancelButton: "custom-cancel-button",
                },
              });
              copyPrintSuccess = retry.isConfirmed;
            } while (!copyPrintSuccess);
          }
   
          resetForm();
          break;
        default:
          NotifyC.error("Ops, ocurrió un error inesperado.", { duration: 6000 });
      }
    } catch (error) {
      NotifyC.error("Ops, ocurrió un error de red o inesperado.", { duration: 6000 });
      console.error(error);
    }

    setLoadingOperation(null); // Limpiar el estado de carga
  };

     const verifyConfirmUser = async (action) => {
       let message, title;
       
                switch (action) {
           case 'EntregarVencido':
             title = "Confirmar Entrega de Giro Expirado";
             message = "¿Desea entregar el giro expirado?";
             break;
           case 'ReintegroVencido':
             title = "Confirmar Reintegro de Giro Expirado";
             message = "¿Desea reintegrar el giro expirado?";
             break;
         case 'Reintegro':
           title = "Confirmar Reintegro";
           message = "¿Desea reintegrar el giro?";
           break;
         default:
           title = "Confirmar Entrega";
           message = "¿Desea confirmar la entrega del giro?";
       }
     
       const result = await Swal.fire({
         title: title,
         text: message,
         icon: "warning",
         showCancelButton: true,
         confirmButtonColor: action === 'Retransmisión' ? "#e2131b" : "white",
         cancelButtonColor: "black",
         confirmButtonText: "Aceptar",
         cancelButtonText: "Cancelar",
         customClass: {
           confirmButton: 'custom-confirm-button',
           cancelButton: 'custom-cancel-button',
         },
       });
     
       return result.isConfirmed;
     }

  const selectRefundType = async () => {
    const result = await Swal.fire({
      title: "Seleccionar tipo de reintegro",
      text: "¿Cuál es el motivo del reintegro?",
      icon: "question",
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: "Completo",
      denyButtonText: "Sin comisión",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: 'custom-confirm-button',
        denyButton: 'custom-confirm-button',
        cancelButton: 'custom-cancel-button',
      },
    });

    if (result.isConfirmed) {
      return 1; // Completo
    } else if (result.isDenied) {
      return 2; // Sin comisión
    }
    return null;
  }
    
  return (  
     <>
        <LockScreen title={"Caja cerrada"} description={"La caja se encuentra cerrada, no se puede realizar operaciones hasta su apertura"} isLock={true}/>
    
        <div className="dashboardCard justify-left" style={{ color: "black" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
        {/* Título */}
        <div className="d-flex align-items-center" style={{ gap: "15px", flex: "1" }}>
            <GiPayMoney size={25} />
            <h5 className="mb-0">Entregar giro</h5>
            <button
                type="button"
                className="btn btn-link p-0 ml-2"
                style={{ 
                    border: "none", 
                    background: "none", 
                    color: "#007bff",
                    fontSize: "18px"
                }}
                onMouseEnter={handleShowTooltip}
                onMouseLeave={handleHideTooltip}
                onFocus={handleShowTooltip}
                onBlur={handleHideTooltip}
                title="Información sobre caducidad de giros"
            >
                <BsInfoCircle />
            </button>
        </div>

        {/* Controles (Select + Botones) */}
        {dataRemittances && (
            <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                {/* Botones dinámicos */}
                {dataRemittances?.IdEstatus === 1 ? (
                    dataRemittances?.IdSucursalDestino === user.IdEstafeta ? (
                        // Si la estafeta de origen y destino son la misma, mostrar ambos botones
                        dataRemittances?.IdSucursalOrigen === dataRemittances?.IdSucursalDestino ? (
                            <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                                <button
                                    type="button"
                                    className="btn btn-blue"
                                    onClick={() => confirmDeliverRemittance("Entregar")}
                                    disabled={loadingOperation !== null}
                                >
                                    {loadingOperation === "Entregar" ? (
                                        <Spinner type={1} size={15} className="mr-1" />
                                    ) : (
                                        <FaCheckCircle size={16} className="mr-1" />
                                    )}
                                    Entregar giro
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-warning"
                                    onClick={() => confirmDeliverRemittance("Reintegro")}
                                    disabled={loadingOperation !== null}
                                >
                                    {loadingOperation === "Reintegro" ? (
                                        <Spinner type={1} size={15} className="mr-1" />
                                    ) : (
                                        <FaAngleDoubleLeft size={16} className="mr-1" />
                                    )}
                                    Reintegrar
                                </button>
                            </div>
                        ) : (
                            // Si solo la estafeta de destino es la misma, mostrar solo entrega
                            <button
                                type="button"
                                className="btn btn-blue"
                                onClick={() => confirmDeliverRemittance("Entregar")}
                                disabled={loadingOperation !== null}
                            >
                                {loadingOperation === "Entregar" ? (
                                    <Spinner type={1} size={15} className="mr-1" />
                                ) : (
                                    <FaCheckCircle size={16} className="mr-1" />
                                )}
                                Entregar giro
                            </button>
                        )
                    ) : (
                        <button
                            type="button"
                            className="btn btn-warning"
                            onClick={() => confirmDeliverRemittance("Reintegro")}
                            disabled={loadingOperation !== null}
                        >
                            {loadingOperation === "Reintegro" ? (
                                <Spinner type={1} size={15} className="mr-1" />
                            ) : (
                                <FaAngleDoubleLeft size={16} className="mr-1" />
                            )}
                            Reintegrar
                        </button>
                    )
                ) : dataRemittances?.IdEstatus === 4 ? (
                    // Para remesas vencidas (status 4), mostrar botones específicos según la sucursal
                    dataRemittances?.IdSucursalDestino === user.IdEstafeta ? (
                        // Si la sucursal de destino es la nuestra
                        dataRemittances?.IdSucursalOrigen === dataRemittances?.IdSucursalDestino ? (
                            // Si la estafeta de origen y destino son la misma, mostrar ambos botones
                            <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                                <button
                                    type="button"
                                    className="btn btn-blue"
                                    onClick={() => confirmDeliverRemittance("EntregarVencido")}
                                    disabled={loadingOperation !== null}
                                >
                                    {loadingOperation === "EntregarVencido" ? (
                                        <Spinner type={1} size={15} className="mr-1" />
                                    ) : (
                                        <FaCheckCircle size={16} className="mr-1" />
                                    )}
                                    Entregar giro expirado
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-warning"
                                    onClick={() => confirmDeliverRemittance("ReintegroVencido")}
                                    disabled={loadingOperation !== null}
                                >
                                    {loadingOperation === "ReintegroVencido" ? (
                                        <Spinner type={1} size={15} className="mr-1" />
                                    ) : (
                                        <FaAngleDoubleLeft size={16} className="mr-1" />
                                    )}
                                    Reintegrar giro expirado
                                </button>
                            </div>
                        ) : (
                            // Si solo la estafeta de destino es la misma, mostrar solo entrega
                            <button
                                type="button"
                                className="btn btn-blue"
                                onClick={() => confirmDeliverRemittance("EntregarVencido")}
                                disabled={loadingOperation !== null}
                            >
                                {loadingOperation === "EntregarVencido" ? (
                                    <Spinner type={1} size={15} className="mr-1" />
                                ) : (
                                    <FaCheckCircle size={16} className="mr-1" />
                                )}
                                Entregar giro expirado
                            </button>
                        )
                    ) : dataRemittances?.IdSucursalOrigen === user.IdEstafeta ? (
                        // Si solo la sucursal de origen es la nuestra, mostrar solo reintegro
                        <button
                            type="button"
                            className="btn btn-warning"
                            onClick={() => confirmDeliverRemittance("ReintegroVencido")}
                            disabled={loadingOperation !== null}
                        >
                            {loadingOperation === "ReintegroVencido" ? (
                                <Spinner type={1} size={15} className="mr-1" />
                            ) : (
                                <FaAngleDoubleLeft size={16} className="mr-1" />
                            )}
                            Reintegrar giro expirado
                        </button>
                    ) : (
                        // Si no es ni origen ni destino, no mostrar botón
                        <div style={{ background: "gray", color: "white" }} className="btn">
                            <IoMdAlert size={16} className="mr-1" /> No autorizado
                        </div>
                    )
                ) : dataRemittances?.IdEstatus === 3 ? (
                    <div style={{ background: "orange", color: "white" }} className="btn">
                        <FaAngleDoubleRight size={16} className="mr-1" /> Giro Reintegrado
                    </div>
                ) : dataRemittances?.IdEstatus === 5 ? (
                    <div style={{ background: "purple", color: "white" }} className="btn">
                        <FaCheckCircle size={16} className="mr-1" /> Giro Expirado Entregado
                    </div>
                ) : dataRemittances?.IdEstatus === 6 ? (
                    <div style={{ background: "brown", color: "white" }} className="btn">
                        <FaAngleDoubleLeft size={16} className="mr-1" /> Giro Expirado Reintegrado
                    </div>
                ) : (
                    <div style={{ background: "green", color: "white" }} className="btn">
                        <FaCheckCircle size={16} className="mr-1" /> Giro entregado
                    </div>
                )}
              <div ref={contentRef}>
                
                </div>
                {/* Botón de Cerrar */}
                <button
                    type="reset"
                    className="btn btn-secondary"
                    onClick={resetForm}
                    disabled={loadingOperation !== null}
                >
                    <MdCancel size={20} /> Cerrar
                </button>
            </div>
        )}
    </div>

    {/* Mensaje de alerta */}
    {dataRemittances?.IdEstatus === 1 && dataRemittances?.IdSucursalDestino !== user.IdEstafeta && (
        <div className="alert alert-warning mt-3 text-left" role="alert">
            <IoMdAlert size={20} className="mr-2" />
            <span style={{ fontSize: "14px" }}>
                Esta estafeta no cuenta con autorización para procesar la entrega de este giro.
            </span>
        </div>
    )}

    {/* Mensaje informativo para giros con misma estafeta de origen y destino */}
    {dataRemittances?.IdEstatus === 1 && 
     dataRemittances?.IdSucursalDestino === user.IdEstafeta && 
     dataRemittances?.IdSucursalOrigen === dataRemittances?.IdSucursalDestino && (
        <div className="alert alert-info mt-3 text-left" role="alert">
            <IoMdAlert size={20} className="mr-2" />
            <span style={{ fontSize: "14px" }}>
                Este giro fue creado y debe entregarse en la misma estafeta. Puede elegir entre entregar o reintegrar según corresponda.
            </span>
        </div>
    )}

    {/* Mensaje de alerta para remesas expiradas */}
    {dataRemittances?.IdEstatus === 4 && (
        <div className="alert alert-danger mt-3 text-left" role="alert">
            <IoMdAlert size={20} className="mr-2" />
            <span style={{ fontSize: "14px" }}>
                Este giro ha expirado.
            </span>
        </div>
    )}

    {/* Mensaje informativo para giros vencidos con misma estafeta de origen y destino */}
    {dataRemittances?.IdEstatus === 4 && 
     dataRemittances?.IdSucursalDestino === user.IdEstafeta && 
     dataRemittances?.IdSucursalOrigen === dataRemittances?.IdSucursalDestino && (
        <div className="alert alert-info mt-3 text-left" role="alert">
            <IoMdAlert size={20} className="mr-2" />
            <span style={{ fontSize: "14px" }}>
                Este giro expirado fue creado y debe procesarse en la misma estafeta. Puede elegir entre entregar o reintegrar según corresponda.
            </span>
        </div>
    )}
</div>

    
        {!dataRemittances && (
            <div className="dashboardCard">
                <form onSubmit={handleSubmit(handleOnSubmit)}>
                    <div
                        className="d-flex"
                        style={{
                            justifyContent: "start",
                            alignItems: "center",
                            gap: "14px",
                        }}
                    >
                        {renderInputForm("pin", "Ingresar PIN", false, "number", BsEnvelope)}
    
                        <div
                            className="d-flex justify-content-center"
                            style={{ gap: "12px" }}
                        >
                            {isLoading ? (
                                <button type="submit" className="btn btn-blue" disabled>
                                    <Spinner type={1} size={15} /> Buscar
                                </button>
                            ) : (
                                <button type="submit" className="btn btn-blue">
                                    <BsSearch /> Buscar
                                </button>
                            )}
                            <button
                                type="reset"
                                className="btn btn-secondary"
                                onClick={resetForm}
                                disabled={isLoading}
                            >
                                <TbZoomReset size={20} /> Reiniciar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        )}
    
        {dataRemittances && (
            <div className="dashboardCard text-left">
                  {steps.map((step, index) => (
                    (step.label || step.icon || step.content) && ( 
                        <div
                            key={index}
                            style={{ marginBottom: "20px", borderBottom: "1px dashed #e3e3e3" }}
                        >
                            {(step.label || step.icon) && ( 
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginBottom: "10px",
                                    }}
                                >
                                    {step.icon && ( 
                                        <div
                                            style={{
                                                width: "30px",
                                                height: "30px",
                                                borderRadius: "50%",
                                                background: `${step.bgIcon}`,
                                                color: step.colorIcon ?? "white",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginRight: "10px",
                                            }}
                                        >
                                            {step.icon}
                                        </div>
                                    )}
                                    {step.label && ( 
                                        <span style={{ fontSize: "18px", fontWeight: "500" }}>
                                            {step.label}
                                        </span>
                                    )}
                                </div>
                            )}
                            {step.content && ( 
                                <div className="px-4">{step.content}</div>
                            )}
                        </div>
                    )
                ))}


            </div>
        )}

        {/* Tooltip personalizado */}
        {showTooltip && (
            <div
                ref={tooltipRef}
                style={{
                    position: "fixed",
                    top: `${tooltipPosition.top}px`,
                    left: `${tooltipPosition.left}px`,
                    zIndex: 9999,
                    backgroundColor: "#ffffff",
                    border: "2px solid #007bff",
                    borderRadius: "8px",
                    padding: "15px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    maxWidth: "400px",
                    fontSize: "13px",
                    lineHeight: "1.4",
                    color: "#333",
                    fontFamily: "Arial, sans-serif"
                }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={handleHideTooltip}
            >
                <div style={{ 
                    fontWeight: "bold", 
                    color: "#007bff", 
                    marginBottom: "8px",
                    fontSize: "14px"
                }}>
                    República de Panamá
                </div>
                <div style={{ 
                    fontWeight: "bold", 
                    marginBottom: "6px",
                    fontSize: "13px"
                }}>
                    Ministerio de Gobierno
                </div>
                <div style={{ 
                    fontWeight: "bold", 
                    marginBottom: "8px",
                    fontSize: "12px"
                }}>
                    Decreto Ejecutivo N° 174 de 29 de junio de 2016
                </div>
                <div style={{ 
                    fontWeight: "bold", 
                    marginBottom: "6px",
                    fontSize: "12px"
                }}>
                    DECRETA:
                </div>
                <div style={{ marginBottom: "6px", fontSize: "12px" }}>
                    <strong>Artículo 1:</strong> El artículo 4 del Decreto Ejecutivo N° 431 de 27 de octubre de 1993, queda así:
                </div>
                <div style={{ marginBottom: "6px", fontSize: "12px" }}>
                    <strong>Artículo 4:</strong> Los giros postales y telegráficos caducarán al año a partir de su emisión y el valor de los mismos, será depositado al Tesoro Nacional.
                    Solo se exceptúan los giros postales y telegráficos en procesos judiciales, los cuales caducarán a los 5 años después de emitidos.
                </div>
                
            </div>
        )}
    </>
  );
};

export default DeliverRemittances;
